var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        [
          _c("v-toolbar-title", [
            _c("div", [
              _c(
                "div",
                { staticClass: "info--text" },
                [
                  _c("v-icon", { attrs: { medium: "" } }, [_vm._v("router")]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Survey Data")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "body-2" }, [
                _vm._v("\n          Summary\n        "),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm.wideForm
        ? _c(
            "v-card",
            { staticClass: "card-bg-4" },
            [
              _c("SurveyDataSummary", {
                staticClass: "mb-2",
                attrs: {
                  "data-ui-component": "Survey Summary",
                  dataSource: _vm.surveyDataSource,
                },
              }),
              _vm._v(" "),
              _c("v-layout"),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }